import { useAuthStore } from '../stores/authStore';

export const useIsSuperAdmin = (): boolean => {
  const user = useAuthStore((state) => state.user);
  return !!user?.isSuperAdmin;
};
